
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { doUpdateRelationship, setUserProfile, useUserProfile, } from "../ducks/userProfile";
import Page from "../components/Page";
import Avatar from "../components/Avatar";
import React, { useEffect, useState } from "react";
import SpinnerPage from "../components/SpinnerPage";
import Popup from "../components/Popup";
import { FaUser } from "react-icons/fa";
import Link from "next/link";
import { useRouter } from "next/router";
import useTranslation from "next-translate/useTranslation";
import { getModeIcon, getModeNameCapitalFirst, getHeighestScore, } from "../util/util";
import Medal from "../components/Medal";
import NumberDisplay from "../components/NumberDisplay";
import profileStyles from "../modules/profile/Profile.module.css";
import { RelationshipStatus } from "@chesshotel/constants";
import { FullLeagueScore } from "@chesshotel/types";
import { useUser } from "../ducks/user";
import { api } from "../services/api";
import { addSentFriendRequest, friendRequest, removeFriend, useFriends, } from "../ducks/friends";
import { useSiteData } from "../ducks/siteData";
import { PlayerWs } from "../services/wsOutRoutes";
export async function fetchUserById(userId: number) {
    const response = await api.get("/relationship/" + userId);
    response.data && setUserProfile(response.data);
}
interface UpdateRelationship {
    userId: number;
    username?: string;
    status: RelationshipStatus;
}
export async function updateRelationship(update: UpdateRelationship) {
    if (update.status === RelationshipStatus.PENDING) {
        friendRequest(update.userId, update.username);
    }
    else {
        const response = await api.post("/relationship/update", update);
        const status = response.data;
        if (status === RelationshipStatus.BLOCKED) {
            PlayerWs.block(update.userId, update.username);
        }
        else if (status === RelationshipStatus.DECLINED) {
            removeFriend(update.userId);
        }
        else if (status === RelationshipStatus.NONE) {
            PlayerWs.unblock(update.userId);
        }
    }
    doUpdateRelationship(update.status);
}
function UserProfile() {
    const { t } = useTranslation("common");
    const router = useRouter();
    const { userId, link } = router.query;
    const userIdNum = parseInt(userId as string);
    const { user } = useUserProfile();
    const { friendList } = useFriends();
    const { id, isGuest } = useUser();
    const [action, setAction] = useState(null);
    const { gamePath } = useSiteData();
    const [friendOpen, setFriendOpen] = useState(false);
    useEffect(() => {
        if (userIdNum)
            fetchUserById(userIdNum);
    }, [userIdNum, friendList]);
    if (!user || user.id !== userIdNum) {
        return null; //<SpinnerPage />;
    }
    function renderButtons() {
        function renderBlockButton() {
            if (user.status !== RelationshipStatus.ACCEPTED &&
                user.status !== RelationshipStatus.PENDING) {
                if (user.status === RelationshipStatus.BLOCKED) {
                    return (<button className="btn btn-base btn-red" onClick={() => {
                            setAction("unblock");
                            setFriendOpen(true);
                        }}>
              {t("Blocked")}
            </button>);
                }
                else {
                    return (<button className="btn btn-base btn-red" onClick={() => {
                            setAction("block");
                            setFriendOpen(true);
                        }}>
              {t("Block")}
            </button>);
                }
            }
        }
        function renderFriendButton() {
            if (user.status !== RelationshipStatus.BLOCKED) {
                if (user.status === RelationshipStatus.ACCEPTED) {
                    return (<button className="btn btn-base btn-blue" onClick={() => {
                            setAction("unfriend");
                            setFriendOpen(true);
                        }}>
              {t("Friend")}
            </button>);
                }
                else if (user.status === RelationshipStatus.PENDING) {
                    return (<button className="btn btn-base btn-blue" onClick={() => {
                            setAction("removeRequest");
                            setFriendOpen(true);
                        }}>
              {t("Friend request sent")}
            </button>);
                }
                else {
                    return (<button className="btn btn-base btn-blue" onClick={() => updateRelationship({
                            userId: user.id,
                            username: user.username,
                            status: RelationshipStatus.PENDING,
                        })}>
              {t("Add friend")}
            </button>);
                }
            }
        }
        return (<div className="flex items-center m-4 space-x-2">
        {renderBlockButton()}
        {renderFriendButton()}
      </div>);
    }
    function renderElo() {
        return user.scores.map((score) => {
            return (<NumberDisplay title={getModeNameCapitalFirst(score.modeId, t)} number={score.elo} fontawesomeIcon={getModeIcon(score.modeId)}/>);
        });
    }
    function renderMedals() {
        return user.scores.map((score) => {
            const leagueNameStr = score.leagueName + " league";
            const tranlatedLeagueName = t(leagueNameStr).toUpperCase();
            return (<div className="flex flex-col items-center pb-8">
          {/* <div className="flex items-center space-x-1"> */}
          {/* <div className="flex items-center justify-center rounded-full ">
                  {getModeIcon(score.modeId)}
                </div> */}
          <div className="mb-1.5 font-semibold">
            {getModeNameCapitalFirst(score.modeId, t)}
          </div>
          {/* </div> */}
          <span className="has-tooltip">
            <span className="tooltip">
              {getModeNameCapitalFirst(score.modeId, t).toUpperCase() +
                    " " +
                    tranlatedLeagueName}
            </span>
            <Medal rank={score.rank} title="RANK" leagueName={score.leagueName} size={"medium"}/>
          </span>
        </div>);
        });
    }
    function renderModal() {
        let header = "";
        let status;
        let btnTitle = "";
        if (action === "block") {
            header = t("Block") + " " + user.username + "?";
            status = RelationshipStatus.BLOCKED;
            btnTitle = t("Block");
        }
        else if (action === "unfriend") {
            header = t("Remove friend") + " " + user.username + "?";
            status = RelationshipStatus.DECLINED;
            btnTitle = t("Remove friend");
        }
        else if (action === "unblock") {
            header = t("Unblock") + " " + user.username + "?";
            status = RelationshipStatus.NONE;
            btnTitle = t("Unblock");
        }
        else if (action === "removeRequest") {
            header = t("Remove friend request");
            status = RelationshipStatus.NONE;
            btnTitle = t("Remove request");
        }
        return (<Popup title={header} onClose={() => setFriendOpen(false)}>
        <button className="btn btn-base btn-blue" onClick={() => {
                setFriendOpen(false);
                updateRelationship({
                    userId: user.id,
                    username: user.username,
                    status,
                });
            }}>
          {btnTitle}
        </button>
        <button className="ml-3 btn btn-outline btn-base" onClick={() => setFriendOpen(false)}>
          {t("Cancel")}
        </button>
      </Popup>);
    }
    function getPrevLink(location) {
        if (location === "/friends") {
            return t("Friends");
        }
        if (location === "/players") {
            return t("Players");
        }
        if (location === gamePath) {
            return t("Game");
        }
    }
    const breadCrums = link ? (<div className="text-xl">
      <button className="text-xl text-orange-400" onClick={() => router.back()}>
        {getPrevLink("/" + link)}
      </button>{" "}
      / {user.username}
    </div>) : (user.username);
    const score: FullLeagueScore = getHeighestScore(user.scores);
    return (<Page title={breadCrums} padded icon={<FaUser />}>
      {friendOpen && renderModal()}

      <div className="flex flex-col justify-between mb-10 md:flex-row">
        <div className="flex items-center space-x-1">
          <Avatar className="w-32 h-32" id={user.id} avatarType={user.avatarType} avatarId={user.avatarId} fbId={user.fbId}/>
          <div className="flex flex-col items-start">
            <div className="mb-0 ml-2 text-xl font-semibold md:text-2xl">
              {user.username}
            </div>
            {score && (<span className="has-tooltip">
                <span className="tooltip">
                  {getModeNameCapitalFirst(score.modeId, t)}
                </span>
                <div className="flex items-center ml-2 space-x-1">
                  <div>{getModeIcon(score.modeId)}</div>
                  <div className="text-base md:text-lg">{score.elo}</div>
                </div>
              </span>)}
          </div>
        </div>

        {user.id !== id && !isGuest && renderButtons()}
      </div>
      {user.scores && user.scores.length > 0 && (<>
          <div className={profileStyles.seasonTitle} style={{ width: "100%" }}>
            {t("Ratings").toUpperCase()}
          </div>
          <div className="flex flex-col flex-wrap items-center mt-5 -ml-2 md:flex-row mb-9">
            {user.scores && renderElo()}
          </div>
          <div className={profileStyles.seasonTitle} style={{ width: "100%" }}>
            {t("Medals").toUpperCase()}
          </div>
          <div className="flex flex-col pt-5 md:space-x-8 md:flex-row mb-9">
            {renderMedals()}
          </div>
        </>)}
    </Page>);
}
export default UserProfile;

    async function __Next_Translate__getStaticProps__196976e983c__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/user',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196976e983c__ as getStaticProps }
  